import { Component, OnInit, ViewChild, Injector, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
const screenfull = require('screenfull');

import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { TranslatorService } from '../../core/translator/translator.service';
import { IUtente, RuoloUtente, UtenteService } from '@app/shared';
import { ThemesService } from '@app/core/themes/themes.service'; // Lo chiamo nel costruttore per far caricare il tema base
import { AssistenzaService, IRicercaAssistenzaParams } from '@app/shared/services/assistenza.service';
import { StatoAssistenza } from '@app/shared/models/assistenza';
import { UtilityService } from '@app/shared/services/utility.service';
import { Subject, Subscription, switchMap, takeUntil, tap, timer } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout
    router: Router;
    selectedLanguage = "";

    isNavSearchVisible: boolean;
    @ViewChild('fsbutton', { static: true }) fsbutton;  // the fullscreen button

    stopTimer = new Subject();
    counterNotifiche: number = 0;
    _user: IUtente;
    isSupervisore: boolean = false;
    userSub: Subscription;

    constructor(public menu: MenuService, public settings: SettingsService, public injector: Injector, 
        public translator: TranslatorService, private utenteService: UtenteService, public themes: ThemesService, private assistenzaService: AssistenzaService, private utility: UtilityService) {

        // show only a few items on demo
        this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
        this.selectedLanguage = this.translator.getLanguageInUse();

        this.userSub = this.utenteService.getCurrentUser().subscribe(user => {

            this._user = user;
            this.isSupervisore = this._user.nomeRuolo == RuoloUtente.SUPERVISORE || this._user.nomeRuolo == RuoloUtente.SUPERUSER;
      
        })

    }

    ngOnInit() {
        this.isNavSearchVisible = false;

        var ua = window.navigator.userAgent;
        if (ua.indexOf("MSIE ") > 0 || !!ua.match(/Trident.*rv\:11\./)) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }

        // Switch fullscreen icon indicator
        /*const el = this.fsbutton.nativeElement.firstElementChild;
        screenfull.on('change', () => {
            if (el)
                el.className = screenfull.isFullscreen ? 'fa fa-compress' : 'fa fa-expand';
        });*/

        this.router = this.injector.get(Router);

        // Autoclose navbar on mobile when route change
        this.router.events.subscribe((val) => {
            // scroll view to top
            window.scrollTo(0, 0);
            // close collapse menu
            this.navCollapsed = true;
        });

        this.getNotifications();

    }

    ngOnDestroy(): void {
        this.stopTimer?.next(null);
        this.userSub?.unsubscribe();
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.toggleLayoutSetting('offsidebarOpen');
    }

    toggleCollapsedSideabar() {
        this.settings.toggleLayoutSetting('isCollapsed');
    }

    isCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }

    toggleFullScreen(event) {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
    }

    // Language
    getLangs() {
        return this.translator.getAvailableLanguages();
    }

    setLang(value) {
        this.translator.useLanguage(value);
        this.selectedLanguage = value;
    }

    // Logout
    logout() {

        this.utenteService.logout();

    }

    getNotifications() {

        const msTimer = 1000 * 60;

        const date: Date = null; // new Date();

        const params: IRicercaAssistenzaParams = {
            page: 1,
            pageSize: 1,
            sortBy: "id",
            stati: [StatoAssistenza.DaConfermare],
            dataDa: this.utility.UTCDateFromLocal(date),
            dataA: this.utility.UTCDateFromLocal(date, true)
        }

        timer(1, msTimer).pipe(
            tap(() => {

            }),
            switchMap(() => this.assistenzaService.ricerca(params, this.assistenzaService.basePath, false)),
            takeUntil(this.stopTimer)
          ).subscribe({ 
            next: (assistenzePaginate) => {
                this.counterNotifiche = assistenzePaginate?.paginationInfo.totalItems ?? 0;
            }
        })

    }

}
